import script from "./MobileSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./MobileSidebar.vue?vue&type=style&index=0&id=11286294&lang=scss"

const __exports__ = script;

export default __exports__